const QUESTION_LABELS: Record<string, string> = {
  "full name": "Nombre completo",
  "first name": "Nombre",
  "last name": "Apellido",
  email: "Correo electrónico",
  "phone number": "Número de teléfono",
  phone: "Teléfono",
  mobile: "Celular",
  city: "Ciudad",
  country: "País",
  company: "Empresa",
  "company name": "Nombre de la empresa",
  "job title": "Cargo",
  website: "Sitio web",
  message: "Mensaje",
};

export const translateFacebookQuestionLabel = (question: string) => {
  const normalized = String(question || "").trim().toLowerCase();
  return QUESTION_LABELS[normalized] || question;
};

export const getFacebookFieldLabel = (
  fieldName: string,
  questionKeys: string[] = []
) => {
  const normalizedFieldName = String(fieldName || "").trim().toLowerCase();
  const matchedQuestion = questionKeys.find(
    (question) => String(question || "").trim().toLowerCase() === normalizedFieldName
  );

  return translateFacebookQuestionLabel(matchedQuestion || fieldName);
};

export const getVisibleFacebookFormFields = (
  fields: { name: string; value: string }[] = []
) =>
  fields.filter((field) => String(field?.value || "").trim().length > 0);
